$(document).ready(function () {
    if ($(".search-index").length) {
        var objDropdowns = $(".search-index div.dropdown");
        var objButton = $(".btn-search-index");


        objDropdowns.each(function () {
            var objSubDropdown = $(this).find('a.dropdown-item');
            var objCurrentDropdown = $(this).find('span.startlabel');

            objSubDropdown.each(function () {
                $(this).on('click', function () {
                    // Get the parent
                    var intParent = $(this).attr('data-parent');
                    // Get the correct filter url
                    var strFitler = $(this).attr('data-filter');
                    // Get the title
                    var strTitle = $(this).html();

                    var strDataAttr = 'data-' + intParent;
                    // Change the label
                    objCurrentDropdown.html(strTitle);
                    // give the correct data for the url
                    objButton.attr(strDataAttr, strFitler);
                });
            });
        });
        objButton.on('click', function () {
            var arrData = $(this).data();
            var strHref = "";
            var arrEndData = [];
            var strData = "";

            for (var i in arrData) {
                // Get the href
                if (i === 'href') {
                    strHref = arrData[i];
                }

                if (i !== 'href' && arrData[i] !== 0) {
                    strData = arrData[i];
                    arrEndData.push(strData);
                }
            }

            location.href = strHref + '?' + arrEndData.join("&");
            return false;
        });
    }
});
